export default "__VITE_ASSET__tuUjoZgr__"